// ----------------------------------------------------------------------
// <copyright file="Izenda.Category.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Category component
 */
!(function () {
  var React = require('react');

  var IconMenu = require('share/components/controls/Izenda.IconMenu');
  var ActionBar = require('share/components/controls/Izenda.ActionBar');
  var CategoryGrid = require('./Izenda.CategoryGrid');
  var Alert = require('share/components/controls/Izenda.Alert');
  var ErrorContainer = require('share/components/controls/Izenda.ErrorContainer');
  var commonMessages = require('share/messages/Izenda.CommonMessages');
  var connect = require('share/enhancers/Izenda.Connect');

  var Category = React.createClass({

    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    onSave: function () {
      var props = this.props;
      var store = props.store;
      var loader = props.loader;      
      var localization = props.localization;
      store.alertMessage = commonMessages.EMPTY_MESSAGE;

      var valManager = this.props.validation;

      valManager.validate()
        .then(function (success) {
          loader.startLoading();
          if (success && !store.hasChange) {
            store.alertMessage = {
              type: 'info',
              message: localization.getText("COMMON_MESSAGES_NO_CHANGES_FOUND")
            };
          } else if (success) {
            return props.confirmFn('Confirmation', {
              description: localization.getText("COMMON_MESSAGES_CONFIRM_SAVE")
            }).then(function () {
              return store.saveCategories();
            });
          }
          return null;
        }.bind(this))
        .then(function (result) {
          if (result && !result.success) {
            valManager.updateErrors(result.messages);
          }
          return null;
        })
        .finally(loader.endLoading.bind(loader));
    },

    /**
    * Handle cancel button's click event
    */
    onCancel: function () {
      var loader = this.props.loader;
      var store = this.props.store;

      loader.startLoading();
      this.props.confirmDirtyForm(store.hasChange)
        .then(store.getInitial.bind(store))
        .finally(loader.endLoading.bind(loader));
    },

    /**
    * Reset validation on security page
    */
    resetValidation: function () {
      this.props.validation.reset();
    },

    /**
    * render button save and cancel
    */
    renderHeader: function () {
      return (<ActionBar onSave={this.onSave} onCancel={this.onCancel} />);
    },

    /**
    * render main grid
    */
    renderGrid: function () {
      var store = this.props.store;
      return <CategoryGrid ref='categoryGrid' store={store} />
    },

    /**
    * render main function
    */
    render: function () {
      var store = this.props.store;
      return (
        <section className="izenda-Wrapper">

          <div className="izenda-Wrapper-header">
            <IconMenu />

            <Alert type={store.alertMessage.type}>{store.alertMessage.message}</Alert>

            {this.renderHeader()}

            <ErrorContainer errors={store.errors} />
          </div>
            
          <div className="izenda-Wrapper-content u_marginLeftRight">
            {this.renderGrid()}
          </div>
        </section>
      );
    },

    componentWillUnmount: function () {
      this.props.store.destroy();
    },

    componentWillMount: function () {
      var loader = this.props.loader;
      var store = this.props.store;

      loader.startLoading();
      store.init()
        .finally(loader.endLoading.bind(loader));
    }

  });

  module.exports = connect()(Category);

}());



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/AdvancedSetting/Category/Izenda.Category.jsx